import config from '@/__config';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
import i18n from '@/i18n';

const endpoints = window.API_BASE_URL && window.API_BASE_URL.data !== undefined && window.API_BASE_URL.data !== '' ? window.API_BASE_URL.data : process.env.VUE_APP_API_BASE_URL;
export default {
  removeToken() {
    localStorage.removeItem('access_token');
    axios.defaults.headers.common['Authorization'] = null;
  },

  getToken() {
    const token = localStorage.getItem('access_token');
    return token ? token : null;
  },

  setToken(token) {
    localStorage.setItem('access_token', token);
    axios.defaults.headers.common['Authorization'] = token;
  },

  getUser() {
    return new Promise((resolve, reject) => {
      const token = this.getToken();
      const route =
        config.auth.user && config.auth.user.url
          ? config.auth.user.url
          : '/auth/v2/user';
      const userKey =
        config.auth.user && config.auth.user.userKey
          ? config.auth.user.userKey
          : 'user';
      axios
        .get(`${endpoints}${route}`, {
          headers: { Authorization: token },
        })
        .then((res) => {
          const lang = res.data.data.locale && res.data.data.locale.code
            ? res.data.data.locale.code
            : 'tw';
          axios.defaults.params = {lang};
          store.dispatch('stone_auth/setCurrentUser', res.data.data);
          store.dispatch(
            'stone_auth/setAdministrator',
            res.data.data.is_administrator,
          );
          resolve(res.data[userKey]);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  login({ email, password }) {
    return new Promise((resolve, reject) => {
      const route =
        config.auth && config.auth.login && config.auth.login.url
          ? config.auth.login.url
          : '/auth/signin';
      axios
        .post(`${endpoints}${route}`, {
          email: email,
          password: password,
        })
        .then((loginRes) => {
          this.setToken(`Bearer ${loginRes.data.access_token}`);
          this.getUser().then((userRes) => {
            setTimeout(() => {
              router.push('/').catch(() => {});
            }, 0);
            resolve(userRes);
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  logout(isPushToLogin = true) {
    return new Promise((resolve, reject) => {
      const route =
        config.auth && config.auth.logout && config.auth.logout.url
          ? config.auth.logout.url
          : '/auth/signout';
      const loginRoute = config.auth.login.route
        ? config.auth.login.route
        : '/signin';
      axios
        .post(`${endpoints}${route}`)
        .then((res) => {
          this.removeToken();
          store.dispatch('stone_auth/removeCurrentUser');
          store.dispatch('app/setFactoryId', null);
          store.dispatch('app/setFactory', null);
          store.dispatch('app/setFactorys', null);
          if (isPushToLogin) {
            setTimeout(() => {
              router.push(loginRoute);
            }, 0);
          }
          resolve(res);
        })
        .catch((err) => {
          this.removeToken();
          store.dispatch('stone_auth/removeCurrentUser');
          setTimeout(() => {
            router.push(loginRoute);
          }, 0);
          reject(err);
        });
    });
  },
  verifyUserEmail(userId, expires, signature) {
    return new Promise((resolve, reject) => {
      const url = `/verifyuseremail/patch/${userId}?expires=${expires}&signature=${signature}`;
      axios
        .post(url)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          if (err.response.data.message === 'Invalid Verify email signature.') {
            reject(err.response.data.message);
          } else {
            alert(err);
          }
        });
    });
  },
  forgetPassword(userId, expires, signature, data) {
    return new Promise((resolve) => {
      const url = `/forgetpassword/patch/${userId}?expires=${expires}&signature=${signature}`;
      axios
        .post(url, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (
            err.response.data.message.password[0] ==
            'The password confirmation does not match.'
          ) {
            alert(i18n.t('驗證密碼與密碼不相同'));
          } else alert(err);
        });
    });
  },
  firstPassword(data) {
    return new Promise((resolve) => {
      axios
        .patch('/auth/first_password', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            if (err.response.data.message === 'password not correct.') {
              alert(i18n.t('密碼錯誤'));
            } else if (err.response.data.message === 'find no email.') {
              alert(i18n.t('帳號不存在'));
            } else if (
              err.response.data.message === 'confirmation not match.'
            ) {
              alert(i18n.t('驗證密碼與密碼不相同'));
            }
          } else alert(err);
        });
    });
  },
};
